<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div :class="'view-taxes-list view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-table :data="taxesLists" style="width: 100%" class="tab-list-tit">
            <el-table-column prop="custfullname" label="税收人全称" align="center" show-overflow-tooltip />
            <el-table-column prop="certificatetype" label="证件类型" align="center" :formatter="certyFormat" />
            <el-table-column prop="certificateno" label="证件号码" align="center" />
            <el-table-column prop="taxesplace" label="税收居民国家/地区" align="center" :formatter="countyFormat" />
            <el-table-column prop="taxesflag" label="企业税收类型" align="center" :formatter="taxFlagFormat" />
            <el-table-column prop="taxestype" label="税收类型" show-overflow-tooltip align="center" :formatter="taxtyFormat" />
            <el-table-column label="操作" align="center" width="300">
                <template slot-scope="scope">
                    <div class="btn-group">
                        <el-button type="yellow" size="small" v-on:click.once="$router.push({name:'taxesinfo',query:{taxiesinfoid:scope.row.taxiesinfoid}})">
                            修改
                        </el-button>
                        <el-button
                            type="red"
                            size="small"
                            v-if="taxesLists.length>1"
                            v-on:click="delTaxes(scope.row.taxiesinfoid)"
                        >
                            删除
                        </el-button>
                        <el-button v-if="scope.row.isexistctler!=='0'" type="blue" size="small" v-on:click.once="$router.push({name:'controllist',query:{taxesflag:scope.row.taxesflag}})">
                            设置控制人
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <div v-if="(taxesLists[0] && taxesLists[0].ctaxestype!=='1')||taxesLists.length===0" class="addTax">
                <el-button type="yellow" v-on:click.once="$router.push({name:'taxesinfo',query:{lock:taxesLists.length!==0,tax:taxesLists.length>0?taxesLists[0].ctaxestype:''}})">
                    <i
                        class="fa fa-plus-circle"
                    /><span>新增涉税居民身份信息</span>
                </el-button>
            </div>
        </el-row>
        <el-dialog
            title="交易密码"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="prompt-info">
                <p class="clear">
                </p>
            </div>
            <div class="investor-tips">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    label-width="108px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                        <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    取消
                </el-button>
                <el-button type="yellow" v-on:click="delTaxesInfo">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "TaxesList",
    mixins: [mixin],
    data () {
        return {
            taxestypes: [],
            taxesLists: [],
            birth: "",
            dialogVisible: false,
            ruleForm: {},
            taxiesinfoid: ""
        };
    },
    created () {
        const info = this.$cache.getUser();
        this.isPwdCheck = this.$cache.getPwdCheck("T5");
        this.getTaxesInfo();
    },
    methods: {
        certyFormat (row, column, value) {
            return this.$cache.getDict("130008", value);
        },
        countyFormat (row, column, value) {
            return this.$cache.getDict("120109", value) || "--";
        },
        taxtyFormat (row, column, value) {
            return this.$cache.getDict("120043", value);
        },
        taxFlagFormat (row, column, value) {
            return this.$cache.getDict("120042", value);
        },
        // 删除税收居民信息
        delTaxes (id) {
            const _this = this;
            _this.taxiesinfoid = id;
            this.$confirm("您确认删除该税收居民身份信息吗？", "税收居民信息删除", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                if(_this.isPwdCheck == true)
                {
                    _this.dialogVisible = true;
                }
                else {
                    _this.delTaxesInfo();
                }
            });
        },
        delTaxesInfo () {
            const _this = this;
            let tradepwd = "";
            if(_this.ruleForm.pwd) {
                tradepwd = this.$util.enc(_this.ruleForm.pwd);
            }
            _this.$util.request("tax/OrgTaxInfo", { taxiesinfoid: _this.taxiesinfoid,tradepwd: tradepwd }, "DELETE").then(res => {
                if (res.data) {
                    _this.dialogVisible = false;
                    _this.taxesLists = _this.taxesLists.filter(item => {
                        return item.taxiesinfoid !== _this.taxiesinfoid;
                    });
                    _this.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                }
            });
        },
        getTaxesInfo () {
            const _this = this;
            this.$util.request("tax/OrgTaxInfo").then(res => {
                if (res.data) {
                    const _info = _this.$cache.getUser();
                    for (let i = 0; i < res.data.length; i++) {
                        let _obj = {
                            custfullname: _info.custfullname,
                            certificatetype: _info.certificatetype,
                            certificateno: _info.certificateno
                        };
                        _obj = res.data[i];
                        _obj.taxesplace = res.data[i].ctaxestype != "1" ? res.data[i].ctaxesplace : "CN";
                        _obj.taxesflag = res.data[i].ctaxesflag || "";
                        _obj.taxestype = res.data[i].ctaxestype;
                        _obj.address = res.data[i].ccompanyaddress.trim();
                        _obj.engaddress = res.data[i].engccompanyaddress;
                        _obj.nogetreason = res.data[i].cnogetreason;
                        _obj.notaxesreason = res.data[i].cnotaxesreason;
                        _obj.taxesno = res.data[i].ctaxesno.trim();
                        _obj.taxiesinfoid = res.data[i].taxiesinfoid;
                        _obj.iscontroller = "0";
                        if (_obj.ctaxesflag) _this.taxesLists.push(_obj);
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss">
/*用户信息 */
.view-taxes-list {
    padding-bottom: 50px;
    .addTax {
        text-align: center;
        padding: 35px 0;
        .el-button {
            font-size: 16px;
            padding: 7px 20px;
            span {
                vertical-align: middle;
            }
        }
        i {
            font-size: 24px;
            margin-right: 5px;
            vertical-align: middle;
        }
    }
}
</style>
